"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newGranularitySplit = exports.getGranularityFromSplits = void 0;
const granularity_1 = require("../reporterDb/granularity");
const dimensions_1 = require("./dimensions");
const getGranularityFromSplits = (splits) => {
    var _a;
    if (!splits)
        return granularity_1.GRANULARITY_TYPES.ALL;
    const granularitySplit = splits.find((split) => split.id === "GRANULARITY");
    return (_a = granularitySplit === null || granularitySplit === void 0 ? void 0 : granularitySplit.value) !== null && _a !== void 0 ? _a : granularity_1.GRANULARITY_TYPES.ALL;
};
exports.getGranularityFromSplits = getGranularityFromSplits;
const newGranularitySplit = (granularity) => {
    return Object.assign(Object.assign({}, dimensions_1.GRANULARITY_DIMENSION), { value: granularity });
};
exports.newGranularitySplit = newGranularitySplit;
